// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"4626255e","357":"7050e47e","509":"a6764774","667":"976a373d","988":"76f6923a"}[chunkId] + ".chunk.js";
};